import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { COLORS } from "@routebot/constants";
import { AuthContext } from "shared/context/auth-context";
import { DemoLeadCaptureContext } from "components/demo/DemoLeadCaptureContext";
import BookDemoModal from "components/demo/BookDemoModal";
import { trackSuiteEvent } from "shared/util/track";

const DemoAccountBadge = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const { requestedDemo, markDemoRequested } = useContext(DemoLeadCaptureContext);
  const [bookDemoOpen, setBookDemoOpen] = useState(false);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginRight: "20px" }}>
      <span
        style={{
          whiteSpace: "nowrap",
          borderRadius: "4px",
          padding: "4px 8px",
          borderColor: COLORS.PRIMARY,
          borderWidth: "1px",
          borderStyle: "solid",
          color: "#fff",
          fontSize: "13px",
        }}
      >
        {t("demoAccountBadge")}
      </span>
      <button
        type="button"
        onClick={() => {
          trackSuiteEvent("Demo — Book a Demo (navbar quiet)", "button_click", { requested: requestedDemo });
          setBookDemoOpen(true);
        }}
        style={{
          whiteSpace: "nowrap",
          borderRadius: "4px",
          padding: "4px 10px",
          backgroundColor: "transparent",
          border: "1px solid #888",
          color: "#fff",
          fontSize: "13px",
          cursor: "pointer",
        }}
      >
        {requestedDemo ? "Call requested ✓" : "Book a call"}
      </button>
      <button
        type="button"
        onClick={auth.logout}
        style={{
          whiteSpace: "nowrap",
          borderRadius: "4px",
          padding: "4px 10px",
          backgroundColor: "transparent",
          border: "1px solid #888",
          color: "#fff",
          fontSize: "13px",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#555";
          e.target.style.borderColor = "#aaa";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "transparent";
          e.target.style.borderColor = "#888";
        }}
      >
        Exit Demo
      </button>
      <BookDemoModal
        show={bookDemoOpen}
        onClose={() => setBookDemoOpen(false)}
        trigger="Demo — Book a Demo (navbar quiet)"
        onSuccess={markDemoRequested}
      />
    </div>
  );
};

export default DemoAccountBadge;
